// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-size: 17px;
    font-family: "Nunito Sans", sans-serif;
    color: #000;
}

* {
    box-sizing: border-box;
    margin: 0px;
    padding: 0px;
}



h1,
h2,
h3,
h4,
h5,
h6 {
    font-weight: 500;
    margin-bottom: 15px;
    line-height: normal;
}

h1 {
    font-size: 48px;
    font-weight: 700;
}

h2 {
    font-size: 42px;
    font-weight: 700;
}

h3 {
    font-size: 28px;
    font-weight: 700;
}

h4 {
    font-size: 26px;
}

h5 {
    font-size: 22px;
}

h6 {
    font-size: 20px;
}

p {
    margin-bottom: 20px;
}

a {
    transition: 0.5s;
}

input[type="search"]::-webkit-search-cancel-button {
    display: none;
}

.container {
    margin-left: auto;
    margin-right: auto;
    padding-left: 25px;
    padding-right: 25px;
    max-width: 1500px;
}

section {
    padding-top: 80px;
    padding-bottom: 80px;
}

select {
    -webkit-appearance: none;
    -moz-appearance: none;
    /* background-image: url('./assets/icons/drop_arrow.svg'); */
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 13px;
    padding: 0 10px !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}


input[type=number] {
    -moz-appearance: textfield;
}

.heading_title {
    max-width: 800px;
    margin: auto;
    margin-bottom: 50px;
    text-align: center;
}



.testimonial .slick-current.slick-active .item {
    background-color: #fff;
    box-shadow: 0px 0px 15px 5px rgba(34, 34, 34, 0.09);
}

.testimonial .slick-slide {
    opacity: 0;
}

.testimonial .slick-active {
    opacity: 1;
}


.blog .slick-list {
    margin: 0 -10px
}

.blog .slick-slide>div {
    padding: 0 10px
}

@keyframes animate-bounceTop {
    0% {
        transform: translateY(0px)
    }

    50% {
        transform: translateY(-7px)
    }

    100% {
        transform: translateY(0px)
    }
}

@media (max-width: 1199px) {
    section {
        padding-top: 70px;
        padding-bottom: 70px;
    }

    h1 {
        font-size: 42px;
    }

    h2 {
        font-size: 38px;
    }

    h3 {
        font-size: 24px;
    }

    h4 {
        font-size: 24px;
    }


}

@media (max-width: 1024px) {
    .testimonial .slick-list {
        margin: 0 -5px;
    }

    .testimonial .slick-slide>div {
        padding: 0 5px;
    }
}

@media (max-width: 768px) {
    h1 {
        font-size: 34px;
    }

    h2 {
        font-size: 28px;
    }

    h3 {
        font-size: 24px;
    }

    h4 {
        font-size: 22px;
    }

    h5 {
        font-size: 20px;
    }

    .container {
        padding-left: 15px;
        padding-right: 15px;
    }

    section {
        padding-top: 50px;
        padding-bottom: 50px;
    }


}

.active,
.active:hover {
    color: #d2ac67;
}

.white_header .active,
.white_header .active:hover {
    color: #359dd0;
}

.lg-img-wrap img {
    border: 3px solid #fff;
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;IACI,eAAe;IACf,sCAAsC;IACtC,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;;;AAIA;;;;;;IAMI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAIrB,4DAA4D;IAC5D,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;IACrB,0BAA0B;AAP9B;;AAUA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;;AAGA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;;;AAIA;IACI,sBAAsB;IACtB,mDAAmD;AACvD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;;AAGJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;;AAGJ;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap');\n\nbody {\n    font-size: 17px;\n    font-family: \"Nunito Sans\", sans-serif;\n    color: #000;\n}\n\n* {\n    box-sizing: border-box;\n    margin: 0px;\n    padding: 0px;\n}\n\n\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    font-weight: 500;\n    margin-bottom: 15px;\n    line-height: normal;\n}\n\nh1 {\n    font-size: 48px;\n    font-weight: 700;\n}\n\nh2 {\n    font-size: 42px;\n    font-weight: 700;\n}\n\nh3 {\n    font-size: 28px;\n    font-weight: 700;\n}\n\nh4 {\n    font-size: 26px;\n}\n\nh5 {\n    font-size: 22px;\n}\n\nh6 {\n    font-size: 20px;\n}\n\np {\n    margin-bottom: 20px;\n}\n\na {\n    transition: 0.5s;\n}\n\ninput[type=\"search\"]::-webkit-search-cancel-button {\n    display: none;\n}\n\n.container {\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 25px;\n    padding-right: 25px;\n    max-width: 1500px;\n}\n\nsection {\n    padding-top: 80px;\n    padding-bottom: 80px;\n}\n\nselect {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n}\n\nselect {\n    /* background-image: url('./assets/icons/drop_arrow.svg'); */\n    background-repeat: no-repeat;\n    background-position: right 12px center;\n    background-size: 13px;\n    padding: 0 10px !important;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n\ninput[type=number] {\n    -moz-appearance: textfield;\n}\n\n.heading_title {\n    max-width: 800px;\n    margin: auto;\n    margin-bottom: 50px;\n    text-align: center;\n}\n\n\n\n.testimonial .slick-current.slick-active .item {\n    background-color: #fff;\n    box-shadow: 0px 0px 15px 5px rgba(34, 34, 34, 0.09);\n}\n\n.testimonial .slick-slide {\n    opacity: 0;\n}\n\n.testimonial .slick-active {\n    opacity: 1;\n}\n\n\n.blog .slick-list {\n    margin: 0 -10px\n}\n\n.blog .slick-slide>div {\n    padding: 0 10px\n}\n\n@keyframes animate-bounceTop {\n    0% {\n        transform: translateY(0px)\n    }\n\n    50% {\n        transform: translateY(-7px)\n    }\n\n    100% {\n        transform: translateY(0px)\n    }\n}\n\n@media (max-width: 1199px) {\n    section {\n        padding-top: 70px;\n        padding-bottom: 70px;\n    }\n\n    h1 {\n        font-size: 42px;\n    }\n\n    h2 {\n        font-size: 38px;\n    }\n\n    h3 {\n        font-size: 24px;\n    }\n\n    h4 {\n        font-size: 24px;\n    }\n\n\n}\n\n@media (max-width: 1024px) {\n    .testimonial .slick-list {\n        margin: 0 -5px;\n    }\n\n    .testimonial .slick-slide>div {\n        padding: 0 5px;\n    }\n}\n\n@media (max-width: 768px) {\n    h1 {\n        font-size: 34px;\n    }\n\n    h2 {\n        font-size: 28px;\n    }\n\n    h3 {\n        font-size: 24px;\n    }\n\n    h4 {\n        font-size: 22px;\n    }\n\n    h5 {\n        font-size: 20px;\n    }\n\n    .container {\n        padding-left: 15px;\n        padding-right: 15px;\n    }\n\n    section {\n        padding-top: 50px;\n        padding-bottom: 50px;\n    }\n\n\n}\n\n.active,\n.active:hover {\n    color: #d2ac67;\n}\n\n.white_header .active,\n.white_header .active:hover {\n    color: #359dd0;\n}\n\n.lg-img-wrap img {\n    border: 3px solid #fff;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
